import { Injectable } from '@angular/core';

export interface HttpCustomError {
    error?: any;
    key?: string;
    statusCode?: number;
}

export interface HttpContext {
    error?: any;
    serviceUrl?: string;
    statusCode?: number;
}

/**
 * abstract service responsible for providing the result's custom errors be used by the various http requests
 */
@Injectable()
export abstract class HttpResultProvider {
    abstract getResultFromKey(resultKey: string): any;
    abstract getCustomErrorFromContext(context: HttpContext): HttpCustomError;
}
